// Bajitos accessory: hydraulic switch box.
// Silhouette = chrome control panel + 3 toggle switches + cable trailing off.
// The cable + asymmetric switch positions read as "mid-hop" rather than static.

interface HydraulicSwitchProps {
  /** Primary fill (panel body). Defaults to tecate gold. */
  bodyColor?: string;
  /** Accent fill (switches + cable). Defaults to chrome silver. */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function HydraulicSwitch({
  bodyColor = '#d4a945',
  accentColor = '#c0c4ca',
  size = 48,
  className,
}: HydraulicSwitchProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Control panel — rounded rectangle with bevel */}
      <rect x="6" y="14" width="32" height="22" rx="2" fill={bodyColor} />
      {/* Top bevel — lighter edge */}
      <rect x="6" y="14" width="32" height="2" fill="rgba(255,255,255,0.3)" />
      {/* Bottom shadow */}
      <rect x="6" y="34" width="32" height="2" fill="rgba(0,0,0,0.25)" />
      {/* Switch 1 — UP position (front hop) */}
      <rect x="11" y="17" width="4" height="10" fill={accentColor} />
      <circle cx="13" cy="17" r="2.5" fill={accentColor} />
      {/* Switch 2 — DOWN position (rear) */}
      <rect x="22" y="22" width="4" height="10" fill={accentColor} />
      <circle cx="24" cy="32" r="2.5" fill={accentColor} />
      {/* Switch 3 — UP position (asymmetric = mid-hop) */}
      <rect x="33" y="17" width="4" height="10" fill={accentColor} />
      <circle cx="35" cy="17" r="2.5" fill={accentColor} />
      {/* Cable — trailing off bottom-right toward the car */}
      <path
        d="M38 30 Q44 34 42 42"
        stroke={accentColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Brand etching on panel face */}
      <rect x="11" y="29" width="26" height="1" fill="rgba(0,0,0,0.3)" />
    </svg>
  );
}
